import React, { Component } from "react";

import "../Assets/Css/App.css";
import "../Assets/Css/Footer.css";
//
export class Blanco extends Component {
  
  render() {
    return (
      <div >
        
      </div>
      
    );
  }
}

export default Blanco;
